const Data = [
    {
        name: "Ashutosh Kr Singh",
        position: "TechOps Head",
        imageUrl: "/assets/images/members/Heads24/Ashutosh Kr Singh.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100085671729571",
        linkedinLink: "https://www.linkedin.com/in/22ee10015ashutoshkrsingh/",
        email: "ashutosh.singh@gyws.org"
    },
    {
        name: "Jatin Mahawar",
        position: "TechOps Head",
        imageUrl: "/assets/images/members/Heads24/JatinMahawar.jpg",
        facebookLink: "https://www.facebook.com/jatin.m.376695?mibextid=ZbWKwL",
        linkedinLink: "https://www.linkedin.com/in/jatin-mahawar-b086a4253?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        email: "jatin.mahawar@gyws.org"
    },
    {
        name: "Harshit Agarwal",
        position:"TechOps Head",
        imageUrl:"/assets/images/members/Heads24/Harshit.jpg",
        facebookLink:"https://www.instagram.com/i_am_harshit002/",
        linkedinLink:"https://www.linkedin.com/in/harshit3478/",
        email:"harshit.agarwal@gyws.org"

    }
]

export default Data;